import { computed } from 'vue';

import { useAuthStore } from '@/entities/auth';
import { isLocationClosed } from '@/entities/location';
import { useLocationSelection } from '@/features/location-switch';

/**
 * Composable для виджета переключения локаций
 * Управляет выпадающим списком локаций и их переключением
 */
export function useLocationSwitcher() {
  const authStore = useAuthStore();
  const { isLoading, selectLocation } = useLocationSelection();

  /**
   * Текущая выбранная локация
   */
  const currentLocation = computed(() => authStore.currentLocation);

  /**
   * Доступные локации для текущей организации.
   * Закрытые скрыты: свитчер — контекст новых действий. Переоткрыть закрытую локацию
   * можно через страницу `/location-switch`, где они показаны отдельной группой.
   */
  const availableLocations = computed(() =>
    authStore.availableLocations.filter((location) => !isLocationClosed(location)),
  );

  /**
   * Есть ли доступные локации для переключения
   */
  const hasMultipleLocations = computed(() => availableLocations.value.length > 1);

  return {
    currentLocation,
    availableLocations,
    hasMultipleLocations,
    isLoading,
    selectLocation,
  };
}
